import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["gradientColor", "opacity", "size", "side"];
import styled from 'foundations-theming/utils';
import { rgba } from '../../utils/color';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const isVertical = side => side === 'top' || side === 'bottom';
const StyledOverhang = styled.div.withConfig({
  displayName: "Overhang__StyledOverhang",
  componentId: "ywncuo-0"
})(({
  theme,
  $gradientColor,
  $side,
  $size,
  $opacity,
  $cssStyles
}) => {
  return Object.assign({
    backgroundImage: `linear-gradient(to ${$side}, ${rgba(theme.color[$gradientColor], 0)}, ${theme.color[$gradientColor]})`,
    background$Size: isVertical($side) ? `100% ${$size}px` : `${$size}px 100%`,
    height: isVertical($side) ? `${$size}px` : 'auto',
    width: !isVertical($side) ? `${$size}px` : 'auto',
    opacity: $opacity,
    pointerEvents: 'none',
    position: 'absolute',
    top: $side !== 'bottom' ? 0 : 'initial',
    bottom: $side !== 'top' ? 0 : 'initial',
    left: $side !== 'right' ? 0 : 'initial',
    right: $side !== 'left' ? 0 : 'initial'
  }, $cssStyles);
});
export const Overhang = _ref => {
  let {
      gradientColor = 'fill-transitional-scroll-default-gradient-color-1',
      opacity = 1,
      size = 14,
      side
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(restProps);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledOverhang, Object.assign({
    $gradientColor: gradientColor,
    $opacity: opacity,
    $size: size,
    $side: side
  }, domProps, {
    $cssStyles: cssStyles
  }));
};
Overhang.displayName = 'Overhang';